var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "plus"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7501 18.8749H4.75006C3.78414 18.8749 3 19.6588 3 20.6247C3 21.5909 3.78414 22.3748 4.75006 22.3748H18.7501V35.4997C18.7501 36.4656 19.5339 37.2497 20.4999 37.2497C21.4661 37.2497 22.2499 36.4656 22.2499 35.4997V22.3748H36.2499C37.2159 22.3748 38 21.5909 38 20.6247C38 19.6588 37.2159 18.8749 36.2499 18.8749H22.2499V5.75006C22.2499 4.78414 21.4661 4 20.4999 4C19.5339 4 18.7501 4.78414 18.7501 5.75006V18.8749Z",
    fill: "#F86557"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.806bd1d2ce957321039c576ca951c575.svg";
export { ForwardRef as ReactComponent };